import React from 'react';
import { Phone, MapPin, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MobileStickyBar() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-brand-hunter text-brand-offwhite z-40 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] pb-safe" data-id="element-105">
      <div className="flex items-center justify-between px-2 py-2" data-id="element-106">
        <a href="tel:507-368-4696" className="flex-1 flex flex-col items-center justify-center py-2 border-r border-brand-offwhite/20" data-id="element-107">
          <Phone className="w-5 h-5 mb-1" data-id="element-108" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-109">
            Call
          </span>
        </a>
        <Link to="/contact" className="flex-1 flex flex-col items-center justify-center py-2 border-r border-brand-offwhite/20" data-id="element-110">
          <MapPin className="w-5 h-5 mb-1" data-id="element-111" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-112">
            Directions
          </span>
        </Link>
        <a href="https://www.facebook.com/profile.php?id=100057537217940" target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center py-2" data-id="element-113">
          <Facebook className="w-5 h-5 mb-1" data-id="element-114" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-115">
            Facebook
          </span>
        </a>
      </div>
    </div>;
}